import { Component, CUSTOM_ELEMENTS_SCHEMA, OnChanges, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ISelectOption } from '../../models/select-option';
import { SelectInputComponent } from '../select-input/select-input.component';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatFormField } from '@angular/material/form-field';

@Component({
  selector: 'app-multiple-checkbox-input',
  templateUrl: './multiple-checkbox-input.component.html',
  styleUrls: ['./multiple-checkbox-input.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CdkTextareaAutosize,
    CommonModule,
    MatCheckbox,
    MatIconModule,
    MatFormField,
  ],
})
export class MultipleCheckboxInputComponent
  extends SelectInputComponent
  implements OnInit, OnDestroy, OnChanges {
  selectedCheckboxes: number[] = [];
  unsubscribe$ = new Subject<void>();

  @ViewChildren(MatCheckbox) checkboxes: QueryList<MatCheckbox> | undefined;

  
 



  ngOnInit(): void {
    super.ngOnInit();

    this.formControl.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.selectedCheckboxes = this.formControl.value;
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  handleChange(event: MatCheckboxChange, option: ISelectOption) {
    if (
      event.checked &&
      (!this.formControl.value?.some(o => o === option.value) || this.formControl?.value == null)
    ) {
      if (this.formControl?.value == null) {
        this.formControl.setValue([]);
      }
      this.formControl.setValue(this.formControl.value?.map(x => x).concat(option.value));
    } else if (!event.checked && this.formControl.value?.some(o => o === option.value)) {
      this.formControl.setValue(this.formControl.value?.filter(o => o !== option.value));
      if (this.formControl.value.length === 0) {
        this.formControl.setValue(null);
      }
    }
    super.onChange();
  }

  controlHasValue(option: ISelectOption) {
    return this.formControl?.value?.some(x => x === option.value) ?? false;
  }

  optionsChanged() {
    setTimeout(() => {
      if (this.checkboxes?.length > 0) {
        for (const checkbox of this.checkboxes) {
          checkbox._inputElement.nativeElement.onblur = () => {
            this.formControl.markAsTouched();
            this.formControl.updateValueAndValidity();
          };

          checkbox._inputElement.nativeElement.onchange = () => {
            this.formControl.markAsDirty();
            this.formControl.updateValueAndValidity();
          };
        }
      }
    });
  }
}
